import React, { use, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// do zmioany
import { toggleAddModal, toggleEditModal } from '../../store/faqTabSlice.js';
import {
  getHeaders,
  headerWidths,
  tabsConfig,
  buttonsConfig,
  empty,
} from './faqTableConfig.js';

// do koniec zmioany

import Table from '../../components/list2/table';
import Menu from '../../components/menu/menu';
import Content from '../../components/content/content';
import LineWithButtons from '../../components/components/line_with_buttons/lineWithButtons.jsx';

import './Faq.css';

import { fetchFaq } from './faqTableService.js';

import AddNewFaq from './addFaq.jsx';
import EditSportModal from './editFaq.jsx';



function Faq() {

  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.faq.activeUsersTab);
  const checkedItems = useSelector((state) => state.faq.checkedItems);
  const addModalOpen = useSelector((state) => state.faq.addModalOpen);
  const editModalOpen = useSelector((state) => state.faq.editModalOpen);
  const keyword = useSelector((state) => state.faq.keyword);
  const searchValue = useSelector((state) => state.faq.searchValue);

  const needRefresh = useSelector((state) => state.faq.needRefresh);

  const [rowsNotif, setRowsNotif] = useState([]);
  const sortArrowColorActive = '#060606';
  const sortArrowColorInactive = '#06060650';

    // Funkcja otwierająca modal (Redux Action)
    const handleToggleAddModal = () => {
      dispatch(toggleAddModal());
    };
    const handleToggleEditModal = () => {
      dispatch(toggleEditModal());
    };

  useEffect(() => {
    fetchFaq(
        dispatch,
        setRowsNotif,
        checkedItems
    );

  }, [checkedItems, needRefresh]);

  const headers = getHeaders(
    dispatch,
    rowsNotif,
    checkedItems);

  return (
    <div>
      {addModalOpen && <AddNewFaq/>}
      {editModalOpen && <EditSportModal />}
      <Menu />
      <Content>
        <LineWithButtons tabs={tabsConfig(activeTab, dispatch)} buttons={buttonsConfig(handleToggleAddModal)} />
      
        <div className="table-container">
            <Table
              headers={headers}
              rowsClass='row-sports'
              cellClass='cell-sports'
              rows={rowsNotif}
              columnWidths={headerWidths}
              idViewing={true}
              idArrayId={1}
              cellClass2='cell-center'
              cellClass2ConditionList={[1]} />
        </div>
      </Content>
    </div>
  );
}

export default Faq;